let listenForParameters;
let useLocalStorage;

export const isRangeType = [ 'numberOfBedrooms', 'area',  'price'];

export const range = (begin, end) => {
  return {
    begin,
    end,
  };
};

const searchTerms = {
  numberOfBedrooms: range(),
  area: range(),
  price: range(),
  facilities: undefined,
  propertyType: undefined,
  county: undefined,
  municipality: undefined,
  cityArea: undefined,
};

const set = (name, value) => {
  if (name) {
    searchTerms[name] = value;

    if (useLocalStorage && localStorage) {
      localStorage.setItem(name, value);
    }
  }
};

const setRange = (name, value1, value2) => {
  if (name) {
    searchTerms[name] = range(value1, value2);

    if (useLocalStorage && localStorage) {
      localStorage.setItem(`${name}Begin`, value1);
      localStorage.setItem(`${name}End`, value2);
    }
  }
};

const getItemFromLocalStorage = (name) => {
  const item = localStorage.getItem(name);

  let ret = undefined;
  if (!(item === 'undefined' || item === 'null')) {
    ret = item;
  }
  return ret;
};

const getUrlParameter = (parameterName) => {
  const parameters = [];
  const hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
  for (let i = 0; i < hashes.length; i++) {
    const hash = hashes[i].split('=');
    parameters.push(hash[0]);
    parameters[hash[0]] = hash[1];
  }

  const value = parameters[parameterName];
  return (value && value !== 'undefined') ? decodeURIComponent(value) : undefined;
};

const getSearchTermValues = (getValueFunc) => {
  Object.keys(searchTerms).forEach(termName => {
    if (termName in isRangeType) {
      const begin = getValueFunc(`${termName}Begin`);
      const end = getValueFunc(`${termName}End`);
      setRange(termName, begin, end);
    } else {
      const termValue = getValueFunc(termName);
      if (termValue) {
        set(termName, termValue);
      }
    }
  })
};

const hasParameters = () => {
  return Object.keys(searchTerms).some(termName => {
    if (termName in isRangeType) {
      if(getUrlParameter(`${termName}Begin`) || getUrlParameter(`${termName}End`)) {
        return true;
      }
    } else {
      if(getUrlParameter(termName)) {
        return true;
      }
    }
    return false;
  });
};

export const initSearchTerms = (listenForParametersToggle = true, useLocalStorageToggle = true) => {
  listenForParameters = listenForParametersToggle;
  useLocalStorage = useLocalStorageToggle;

  if (listenForParameters && hasParameters()) {
    localStorage.clear();
    getSearchTermValues(getUrlParameter);
  } else if (useLocalStorage && localStorage) {
    getSearchTermValues(getItemFromLocalStorage);
  }

  searchTerms.setRange = setRange;
  searchTerms.set = set;
  return searchTerms;
};
